export default __webpack_public_path__ + "static/petr-zabystrzan-0e878e9e2d07b2170b2777766ccb9c0f.jpg";